
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"icon-fill",attrs:{"fill":"#fff","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M3.751 5.75C4.478 6.508 5.662 7 7 7c1.346 0 2.537-.499 3.262-1.263C12.49 6.802 14 8.867 14 10.864c0 2.864-3.106 2.325-6.972 2.325-3.866 0-7.028.54-7.028-2.325 0-1.989 1.525-4.043 3.751-5.113z"}}),_c('circle',{attrs:{"cx":"7","cy":"3","r":"3"}})])])
          )
        }
      }
    